<template>
  <!-- Ícone lucide, desenhado inline. O traço mora aqui, não nos caminhos: assim um
       tamanho novo não pede um arquivo novo. -->
  <svg
    class="ic"
    :class="[`ic-${size}`, { 'ic-filled': filled }]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    v-html="path"
  />
</template>

<script>
import paths from './icon-paths';

export default {
  name: 'AppIcon',
  props: {
    name: { type: String, required: true },
    /** `sm` 13 · `md` 16 · `lg` 20 (navegação, diretiva 10) · `xl` 24. */
    size: { type: String, default: 'md' },
    /**
     * Preenche o desenho mantendo o traço. O lucide é uma família de contorno: trocar o
     * traço por preenchimento, como a versão anterior fazia, transformava estrela e chama
     * em manchas.
     */
    filled: { type: Boolean, default: false },
  },
  computed: {
    path() {
      return paths[this.name] || '';
    },
  },
};
</script>

<style scoped>
.ic {
  width: 16px;
  height: 16px;
  flex: none;
  stroke-width: 1.9;
}

.ic-sm { width: 13px; height: 13px; }
.ic-lg { width: 20px; height: 20px; }
.ic-xl { width: 24px; height: 24px; }

.ic-filled { fill: currentColor; }
</style>
